// Singleton to manage global city context
class CityContextManager {
    private static instance: CityContextManager;
    private currentCity: string = ""; // Changed from 'Salvador' to null
    private lastUpdated: number = 0; // No initial timestamp

    private listeners: ((city: string) => void)[] = [];
  
    private constructor() {
    }
  
    static getInstance(): CityContextManager {
      if (!CityContextManager.instance) {
        CityContextManager.instance = new CityContextManager();
      }
      return CityContextManager.instance;
    }
  
    setCurrentCity(city: string) {
      if (city && city.trim()) {
        console.log('[CityContext] Updating current city:', city);
        this.currentCity = city.trim();
        this.lastUpdated = Date.now();
        this.notifyListeners();
      }
    }
  
    getCurrentCity(): string {
      return this.currentCity; // Return null if no city is set
    }

     getLastUpdated(): number {
      return this.lastUpdated;
    }
  
    addListener(listener: (city: string) => void) {
      this.listeners.push(listener);
    }

    // Add a check method
    hasCityContext(): boolean {
      return this.currentCity.trim() !== "";
    }
  
    removeListener(listener: (city: string) => void) {
      this.listeners = this.listeners.filter(l => l !== listener);
    }
  
    private notifyListeners() {
      this.listeners.forEach(listener => listener(this.currentCity));
    }
  }
  
  export const cityContext = CityContextManager.getInstance();